import type { DataFeedsOwnS3BucketChoice, StackDeploymentType } from './types'

export const parseStackDeploymentType = (
  raw: string | undefined
): StackDeploymentType | undefined => {
  const normalized = raw?.trim().toLowerCase()
  if (normalized === 'cloudformation' || normalized === 'terraform') {
    return normalized
  }
  return undefined
}

export const normalizeStackDeploymentType = (
  raw: string | undefined
): StackDeploymentType => {
  const normalized = raw?.trim().toLowerCase()
  return normalized === 'terraform' ? 'terraform' : 'cloudformation'
}

export const normalizeDataFeedsOwnS3Choice = (
  raw: string | undefined
): DataFeedsOwnS3BucketChoice => {
  const normalized = raw?.trim().toLowerCase()
  return normalized === 'yes' ? 'yes' : 'no'
}

export const parseDataFeedsOwnS3Choice = (
  raw: string | undefined
): DataFeedsOwnS3BucketChoice | undefined => {
  const normalized = raw?.trim().toLowerCase()
  if (normalized === 'yes' || normalized === 'no') {
    return normalized
  }
  return undefined
}
